import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import MainImg from "../../../assets/img/blog/march/MainVisit.webp"; 
import Fultons from "../../../assets/img/blog/march/Fultons.webp"; 
import Jireh from "../../../assets/img/blog/march/Jireh.webp"; 
import Rusty from "../../../assets/img/blog/march/Rusty.webp"; 
import Shaws from "../../../assets/img/blog/march/Shaws.webp"; 
import White from "../../../assets/img/blog/march/White.webp"; 

const MARCH_FARMS = [
  {
    farms: [
      {
        name: "1. Fulton's Sugar Bush & Shop",
        img: Fultons,
        subTitle: "Nestled between the charming communities of Almonte and Pakenham.",
        description: "Nestled between the charming communities of Almonte and Pakenham, Fulton’s Sugar Bush & Maple Shop is one of Lanark County’s maple syrup farms with over 175 years of history. This family-run farm offers a warm and welcoming atmosphere, making it a perfect destination for a classic maple syrup tour. Visitors can explore scenic trails, enjoy sweet maple treats, and take part in fun farm trips near Toronto.",
        location: "399 Sugar Bush Rd, Pakenham, ON K0A 2X0",
        website: "Fulton's Sugar Bush & Shop",
        webUrl: "https://www.fultons.ca/",
        details: [
          { label: "Maple Syrup Experience", value: "Take a guided sugar bush tour through scenic maple tree groves, where you’ll learn about the history and techniques of tree tapping and maple syrup production. The tour concludes with a warm syrup tasting for the ultimate maple experience." },
          { label: "Dates", value: "March 1 – April 20, 2025" },
          { label: "Schedule", value: "Open daily | Monday – Friday: 10:00 AM – 3:00 PM | Saturday & Sunday: 10:00 AM – 4:00 PM" },
          { label: "Activities", value: "Explore scenic maple trails on foot, snowshoes, or skis | Enjoy a classic maple taffy treat | Browse the Maple Store for syrup, butter, and baked goods | Guided tour discovering tree tapping, sap collection, and syrup-making process" },
          { label: "Admission", value: "Admission is $10 per vehicle for a day pass or $40 per month for unlimited trail access." },
          { label: "Included", value: "Free parking | Access to farm trails and play areas | Maple taffy experience on select days | Picnic and relaxation spots" },
          { label: "Important Notes", value: "Online reservations only | Dress for changing weather | Dogs are welcome | Food may contain allergens | Non-refundable tickets" }
        ]
      },
      {
        name: "2. Jireh Hills Family Homestead",
        img: Jireh,
        subTitle: "Jireh Hills Farm offers the ultimate farm trip in southwest Ontario.",
        description: "Jireh Hills Farm offers the ultimate farm trip in southwest Ontario, where you can escape the city and enjoy the charm of rural life with the comforts of home. Choose from Nature Lodges, Seasonal Glamping RV, BYO Camper, or Off-Grid Camping, and take part in daily farm chores like milking goats, feeding alpacas, and collecting eggs. Enhance your stay with discounted farm experiences such as goat snuggles, alpaca walks, pony rides, and homesteading classes in cheese and soap making for a truly immersive getaway.",
        location: "", // No exact address provided in snippet
        website: "Jireh Hills Family Homestead",
        webUrl: "https://jirehhills.com/",
        details: [
           { label: "Dates", value: "Overnight stays available year-round" },
           { label: "Open Hours", value: "Varies by activity – please refer to the website for detailed schedules | Check-In: 2:00 PM | Check-Out: 11:00 AM" },
           { label: "Activities", value: "Farm Stay Experience (Nature Lodges, Glamping, Off-Grid Camping) | Guided Farm Chores (Milking Goats, Feeding Alpacas, Collecting Eggs) | Goat Snuggles & Encounters | Alpaca Walks in the Woodlands | Pony Rides and Encounters | Homesteading Classes (Cheese Making, Soap Making, Goat Keeping, Earth to Table) | Farm & Forest School (Little Farmers - Ages 5+)" },
           { label: "Admission", value: "Please refer to our website for detailed pricing on accommodations, farm experiences, and homesteading classes." },
           { label: "Included", value: "Enjoy private and group campfire areas with firewood | Picnic spots near the woods and farm animals | Unlimited playtime at the Woodland Adventure Playground | Scenic forest trails along the Froggie Boggie Boardwalk | Serene views of playful goats, alpacas, and the Blue Heron Lagoon" },
           { label: "Important Notes", value: "Overnight stays require advance booking | Farm stays and activities operate in all seasons—dress appropriately. | Leashed dogs are welcome but must be supervised at all times. | To maintain a peaceful environment, loud noise and disruptive behavior are not permitted." },
           { label: "Book Here", value: "https://jirehhills.com/" }
        ]
      },
      {
        name: "3. Rusty Jade Ranch",
        img: Rusty,
        subTitle: "Located just an hour from downtown Toronto in Palgrave, Ontario.",
        description: "Located just an hour from downtown Toronto in Palgrave, Ontario, spans 96 acres of picturesque landscape. This family-owned ranch offers a serene escape from urban life, providing a variety of equestrian experiences suitable for all ages and skill levels. Whether you’re planning a family outing or seeking personal relaxation, Rusty Jade Ranch presents an ideal setting to connect with nature and enjoy diverse programs.",
        location: "18070 Duffy's Lane, Palgrave, ON L7E 3C4",
        website: "Rusty Jade Ranch",
        webUrl: "https://www.rustyjaderanch.com/",
        details: [
          { label: "Dates", value: "Year-round, with seasonal programs and events" },
          { label: "Operation Hours", value: "Monday to Friday: 8:30 AM – 9:30 PM | Saturday: 9:00 AM – 5:30 PM | Sunday: 10:00 AM – 5:00 PM" },
          { label: "Activities", value: "Horseback riding lessons | Guided trail rides | Summer camps for all levels | Creative art parties" },
          { label: "Admission", value: "Adults (22+) $30 | Young Adults (15–21) $20 | Children (5–14) $10 / under 5 free" },
          { label: "Included", value: "Complimentary parking | Access to ranch trails and picnic areas | On-site restrooms" },
          { label: "Important Notes", value: "Events may be rescheduled due to weather | Tickets are non-refundable | Outdoor attire recommended | Outside food and pets not allowed | Children under 5 receive free admission for daily visits." },
          { label: "Book Here", value: "https://www.rustyjaderanch.com/" }
        ]
      },
      {
        name: "4. Shaws Maple Syrup",
        img: Shaws,
        subTitle: "Established in 1904, Shaw’s Maple Syrup Farm is a family-owned operation.",
        description: "Established in 1904, Shaw’s Maple Syrup Farm is a family-owned operation nestled in Oro-Medonte, Ontario. Visitors are invited to explore the traditional art of maple syrup production, stroll through the scenic sugar bush, and savour delightful meals at the on-site Pancake House. On weekends, horse-drawn wagon rides offer a charming tour of the property, making it a perfect destination for a memorable farm visit in Ontario.",
        location: "493 Oro-Medonte Line 14 South, Oro-Medonte, ON L3V 8J3",
        website: "Shaws Maple syrup",
        webUrl: "https://shawsmaplesyrupandbush.com/",
        details: [
          { label: "Maple Syrup Experience", value: "Immerse yourself in the rich tradition of maple syrup making at Shaw’s. Witness the process from sap collection to syrup production, enjoy horse-drawn wagon rides on weekends, and treat yourself to fresh pancakes topped with pure maple syrup in the rustic Pancake House" },
          { label: "Dates", value: "February 15 to April 13, 2025" },
          { label: "Operation Hours", value: "Daily from 8:00 AM to 4:00 PM" },
          { label: "Activities", value: "Enjoy guided maple syrup production tours | Weekend horse-drawn wagon rides | Self-guided walks through the sugar bush | Dining at the Pancake House | Shopping for maple products at the Maple Tree't shop" },
          { label: "Admission", value: "While entry to the farm is free, the Pancake House menu items are individually priced. For example, a meal including two pancakes or two slices of French toast with warm maple syrup, butter, and two pure pork sausages is priced at $15.00." },
          { label: "Included", value: "Free parking | Access to farm trails and picnic areas | Complimentary weekend horse-drawn wagon rides | On-site restrooms | Entry to the Maple Tree't shop for maple product shopping" },
          { label: "Important Notes", value: "No advance booking required; walk-ins are welcome. | Activities proceed in various weather conditions; please dress accordingly. | Pets are not permitted on the premises. | Major credit cards and cash accepted. | Facilities are wheelchair accessible." }
        ]
      },
      {
        name: "5. White Meadows Farms",
        img: White,
        subTitle: "Specializes in producing pure maple syrup and offers immersive experiences.",
        description: "White Meadows Farms, a fourth-generation family-owned establishment in St. Catharines, Ontario, specializes in producing pure maple syrup and offers immersive experiences for visitors to explore the tradition of maple syrup making.",
        location: "2519 Effingham St, Pelham, ON L2R 6P7",
        website: "White Meadows Farms",
        webUrl: "https://whitemeadowsfarms.com/",
        details: [
          { label: "Dates", value: "Open year-round" },
          { label: "Open Hours", value: "Monday to Saturday: 10:00 AM – 5:00 PM | Sunday: 11:00 AM – 5:00 PM" },
          { label: "Maple Syrup Experience", value: "Embark on a guided walking tour through the sugar bush to learn about the history and process of maple syrup production. The experience includes a tractor-pulled wagon ride and a maple taffy-on-snow tasting. | Dates: Weekends from March 1 to April 13, 2025, and daily during March Break (March 10–14) | Operating Hours: Tours depart every 20 minutes between 10:00 AM and 3:00 PM." },
          { label: "Activities", value: "Experience guided maple tours | Tractor-pulled wagon rides | Maple taffy-on-snow tastings | Maple-inspired charcuterie boards | Educational school tours | Customized farm experiences for groups" },
          { label: "Admission", value: "General (ages 12+): $25.00 +HST | Children (ages 3–11): $15.00 +HST" },
          { label: "Included", value: "Free on-site parking | Access to scenic farm trails and picnic areas | On-site restrooms | Entry to the Maple Sweet Shop for maple products and souvenirs" },
          { label: "Important Notes", value: "Advanced booking is recommended for tours and experiences to ensure availability | As tours involve outdoor activities, please dress appropriately for the weather conditions. | Pets are not permitted on the tours to ensure the safety and comfort of all guests | Major credit cards and cash are accepted for purchases and tour fees. | While efforts are made to accommodate all guests, some areas of the farm may have uneven terrain. Guests with mobility concerns are encouraged to contact the farm in advance to discuss accessibility options." }
        ]
      }
    ]
  }
];

export default function March() {
  return (
    <div className={styles.page}>

      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Best Farm</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti News</span>
        <span className={styles["sep"]}>•</span>
        <span>Posted Mar 5, 2025</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>The Best Farm to visit in March 2025</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={MainImg}
          alt="Best Farms"
        />
      </div>

      <div className={styles["lead-section"]}>
        <p><strong>March is one of the best times to visit Ontario farms, with the sweet scent of maple syrup in the air and the first signs of spring emerging.</strong><br />
        Whether you’re looking for a hands-on maple syrup tour, a cozy farm stay, or a chance to meet friendly alpacas, these family farms in Ontario offer unique and memorable activities for all ages.</p>
        <p>Here’s a list of the best farms in Ontario to visit this March, featuring must-try experiences, spring farm activities, and key details to help plan your visit.</p>
      </div>

      <div className={styles["jump-links"]}>
        {/* Simple jump link placeholder if needed, or removing if not grouped by region */}
      </div>

      {MARCH_FARMS.map((region, idx) => (
        <div key={idx}>
          {region.region && (
            <>
            <h2 className={styles["region-title"]}>{region.region}</h2>
            <hr className={styles["region-divider"]} />
            </>
          )}
          
          {region.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
              
              <div className={styles["farm-description"]}>
                <p><strong>{farm.subTitle}</strong></p>
                <p>{farm.description}</p>
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                {farm.location && (
                  <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Location:</span> {farm.location}
                  </li>
                )}
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Website:</span><br />
                  <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                    {farm.website}
                  </a>
                </li>
                {farm.details && farm.details.map((detail, dIdx) => {
                  
                  const isHighlightBox = ["Important Notes", "Maple Syrup Experience", "Included"].includes(detail.label);
                  const isBulletList = ["Activities", "Admission", "Schedule", "Open Hours", "Operation Hours", "Dates"].includes(detail.label);
                  const isLink = detail.label === "Book Here";

                  if (isLink) {
                     return (
                      <li key={dIdx} className={styles["details-item"]}>
                         <span className={styles["details-label"]}>{detail.label}:</span> <br/>
                         <a href={detail.value} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                            Visit Booking Page
                         </a>
                      </li>
                     );
                  }

                  // Common logic for splitting content into items
                  let contentItems = [];
                  if (detail.value.includes('|')) {
                    contentItems = detail.value.split('|').map(s => s.trim());
                  } else {
                    contentItems = [detail.value];
                  }

                  if (isHighlightBox) {
                    return (
                      <li key={dIdx} className={styles["highlight-detail"]}>
                        <span className={styles["highlight-label"]}>{detail.label}</span>
                        <div className={styles["highlight-content"]}>
                          <ul className={styles["highlight-list"]}>
                            {contentItems.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </li>
                    );
                  }

                  if (isBulletList) {
                    return (
                      <li key={dIdx} className={styles["details-item"]}>
                        <span className={styles["details-label"]}>{detail.label}:</span>
                        <ul className={styles["highlight-list"]} style={{ marginTop: '8px', marginBottom: '0' }}>
                          {contentItems.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </li>
                    );
                  }

                  return (
                    <li key={dIdx} className={styles["details-item"]}>
                      <span className={styles["details-label"]}>{detail.label}:</span> {detail.value}
                    </li>
                  );
                })}
              </ul>
              <hr className={styles["farm-divider"]} />
            </div>
          ))}
        </div>
      ))}

      <div className={styles["lead-section"]}>
        <h2 className={styles["title"]} style={{ fontSize: '2rem', marginTop: '3rem' }}>Ready for Spring Fun?</h2>
        <p>There is no better way to welcome spring than by exploring Ontario's farms. Pick up some fresh maple syrup, enjoy a wagon ride, or introduce the kids to friendly barnyard animals - these March farm visits are sure to create lasting family memories. Happy planning!</p>
      </div>
    </div>
  );
}
